module.exports = __webpack_public_path__ + "static/img/pic_nodota@2x.6900ebac.png";